import React from 'react';
import Icon from './Icon';

const SearchIcon = (props) => (
    <Icon {...props}>
        <path d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default SearchIcon;